jQuery(document).ready(function ($) {

    function openHelpMenu() {
        $('.helpMenu').show();
        $('.helpMenu').addClass('is-open');
    }

    function closeHelpMenu() {
        $('.helpMenu').removeClass('is-open');
        setTimeout(function() {
            $('.helpMenu').hide();
        }, 300);
    }

    $('.helpButton').on('click', openHelpMenu);
    $('.helpMenu__closeButton, .helpMenu__overlay').on('click', closeHelpMenu);
    
});